import { useEffect, useRef } from 'react';

const GOOGLE_CLIENT_ID = '65945332176-lbgfl9sb72tbungbh45i7oobgb8npvec.apps.googleusercontent.com';

function GoogleSignInButton({ onCredential, disabled }) {
  const btnRef = useRef(null);
  const initialized = useRef(false);

  useEffect(() => {
    if (initialized.current) return;

    const renderButton = () => {
      if (!window.google?.accounts?.id || !btnRef.current) return;
      window.google.accounts.id.initialize({
        client_id: GOOGLE_CLIENT_ID,
        callback: (response) => {
          if (response.credential) onCredential(response.credential);
        },
      });
      window.google.accounts.id.renderButton(btnRef.current, {
        type: 'standard',
        theme: 'outline',
        size: 'large',
        width: btnRef.current.offsetWidth || 320,
        text: 'continue_with',
      });
      initialized.current = true;
    };

    // Load the GSI script if not loaded
    if (!document.getElementById('google-gsi-script')) {
      const script = document.createElement('script');
      script.id = 'google-gsi-script';
      script.src = 'https://accounts.google.com/gsi/client';
      script.async = true;
      script.defer = true;
      script.onload = renderButton;
      document.head.appendChild(script);
    } else {
      renderButton();
    }
  }, [onCredential]);

  return (
    <div
      ref={btnRef}
      style={{
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        minHeight: '44px',
        opacity: disabled ? 0.5 : 1,
        pointerEvents: disabled ? 'none' : 'auto',
      }}
    />
  );
}

export default GoogleSignInButton;
